import { Stack, Text } from '@mantine/core';

export function BillingDetailItem({ label, value }: { label: string; value: string }): JSX.Element {
  return (
    <Stack gap={2}>
      <Text size="xs" c="dimmed" tt="uppercase" fw={600}>
        {label}
      </Text>
      <Text size="sm">{value || '—'}</Text>
    </Stack>
  );
}
